import React, { useEffect, useState } from 'react';
import { Nav, Navbar, Container, NavDropdown, Form, Button, InputGroup, Image } from 'react-bootstrap';
import { IoSearchOutline } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useAuth } from '../../features/auth/hooks/useAuth';
import CartIcon from './CartIcon';
import { AiOutlineLogout } from 'react-icons/ai';
import { useCarts } from '../../features/products/hooks/useCart';
import { useProfile } from '../../features/profile/hooks/useProfile';

const NavbarComp = ({ searchProduct }) => {

  const navigate = useNavigate();
  const { validate } = useAuth();
  const { fetchCartsByIdUser, cart } = useCarts();
  const { fetchProfile, profile } = useProfile();

  const [textCari, setTextCari] = useState({
    cari: ''
  })

  const logout = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will be logged out!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, Logout!',
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem('token');
        localStorage.removeItem('user'); // If you store user data
        sessionStorage.clear(); // Clear session storage if needed

        Swal.fire({
          icon: 'success',
          title: 'Logged Out',
          text: 'You have been logged out successfully.',
          confirmButtonText: 'OK',
        }).then(() => {
          navigate('/auth'); // Redirect to login page
        });
      }
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTextCari((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  }

  const handleClickCari = () => {
    const param = textCari.cari
    searchProduct(param);
  }

  const handleClickProfile = () => {
    navigate("/profile")
  }

  const handleClickHome = () => {
    navigate("/")
  }

  useEffect(() => {
    // (async () => {
    //   const userData = await validate();
    //   setUser(userData);
    // fetchCartsByIdUser();
    // fetchProfile();
    // validate();

  }, [
    validate,
    fetchCartsByIdUser,
    fetchProfile
  ]);

  return (
    <>
      <Navbar
        style={{
          background: "transparent", // Make it transparent
          height: 50,
          cursor: 'pointer'
        }}
        bg="transparent" // Ensure Bootstrap applies transparency
        expand="lg"
        sticky="top"
      >
        <Container style={{
          background: "transparent"
        }}>
          <Navbar.Brand id="navbarScroll"
            style={{
              background: "transparent",
              color: "green",
              marginLeft: "0px",
              marginRight: "15px"
            }}
            onClick={handleClickHome}>
            <img
              src="/logo-yarsi.png"  // Public folder image
              width="25"
              height="25"
              className="d-inline-block align-top"
              alt="Rumah Sakit Yarsi"
            />
          </Navbar.Brand>

          <Nav
            className="me-auto my-3 my-lg-0"
            style={{ background: "transparent", maxHeight: '100px' }}
            navbarScroll
          >

          </Nav>
          <Navbar.Toggle aria-controls="navbarScroll" style={{ background: "transparent", alignContent: 'center' }} />
          <Navbar.Collapse id="navbarScroll" style={{ background: "transparent", alignContent: 'center' }}>

            <Nav
              className="me-auto my-1 my-lg-0"
              style={{ maxHeight: '100px' }}
              navbarScroll
            >
              <InputGroup size="sm">
                <Form.Control
                  placeholder="Cari produk"
                  aria-label="Cari produk"
                  aria-describedby="basic-addon2"
                  style={{
                    border: 'none',
                    borderBottom: '2px solid #ccc',
                    borderRadius: 0,
                    boxShadow: 'none',
                    background: "transparent"
                  }}
                  value={textCari.cari}
                  name='cari'
                  type='text'
                  onChange={(e) => handleChange(e)}
                />
                <Button
                  variant="outline-success"
                  id="button-addon2"
                  style={{
                    border: 'none',                     // Remove button border
                    boxShadow: 'none',                  // Remove any default shadow
                    background: "transparent"
                  }}
                >
                  <IoSearchOutline onClick={handleClickCari} style={{ fontSize: '1.2rem' }} />
                </Button>
              </InputGroup>
            </Nav>

            <Nav.Link style={{
              background: "transparent"
            }} className="d-flex justify-content-between align-items-center p-1">
              <CartIcon cart={cart} />
            </Nav.Link>
            {/* {Object.keys(token || 0).length > 0 ?
            <Nav.Link style={{ color: "gray", marginLeft: "10px", marginRight: "0px", fontWeight: 700 }} className='p-1' href="">
              <Image src={user.foto} roundedCircle style={{ alignSelf: 'center', height: '30px', width: '30px' }} />
            </Nav.Link> : ''} */}

            <Nav.Link
              style={{
                // color: "gray",
                marginRight: "10px",
                fontWeight: 700
              }}
              className='p-1'
              onClick={handleClickProfile}>
              <Image
                src={profile[0]?.image_profile ? profile[0]?.image_profile : "/icons8-man-48.png"} // Use default if no image
                alt="User Profile"
                roundedCircle
                style={{ alignSelf: "center", height: "27px", width: "27px" }} />
            </Nav.Link>

            {/* <NavDropdown align='end' style={{
              fontWeight: 700,
              color: "gray",
              marginRight: "25px"
            }} className='p-1' id="navbarScrollingDropdown"> */}
            {/* <NavDropdown.Item eventKey="4.1">
              Masuk
            </NavDropdown.Item>
            <NavDropdown.Item eventKey="4.3">Pengaturan
            </NavDropdown.Item>
            <NavDropdown.Item href="#" to="#" eventKey="4.3"> My Order
            </NavDropdown.Item>
            <NavDropdown.Divider /> */}
            {/* <NavDropdown.Item
                eventKey="4.5"
                onClick={logout}
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <span>Logout</span>
                <AiOutlineLogout size={23} />
              </NavDropdown.Item> */}
            {/* </NavDropdown> */}

          </Navbar.Collapse>

        </Container>
      </Navbar>
    </>
  );
};

export default NavbarComp;
